import axios from 'axios';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {portData} from '../features/port';
import {loginData} from '../features/login';
import  secureLocalStorage  from  "react-secure-storage";

   
const Login = ({setToken}) => {

    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const [EnableRemote, setEnableRemote] = useState(false);
    const [BackEndError, setBackEndError] = useState(false);
    const [isC, setISCntrl] = useState(false);


    const f = 1;

    
    const openSocket = async (e) => {
        console.log(`Calling open socket`)
        const port = parseInt( secureLocalStorage.getItem('port'));
        const hash = ( secureLocalStorage.getItem('hash'));
        //chiedo al backend di aprire una webosck 
        let sessionRef =  secureLocalStorage.getItem('sessionRef');
                
        const res = await axios.post("http://95.110.236.199:3001/port/", {port: port,  username: username, hash: hash, sessionRef: sessionRef})
        .then(function (response) {
            console.log(response);
            if(response.statusText  === 'OK'){
                const isC = response.data.split('|').at(1);
                // setISCntrl(isC);
                
                console.log('set isC a ', isC);
                secureLocalStorage.setItem('isC', isC);
                setEnableRemote(true)
            }
        })
        .catch(err => console.log(err));
    }

    const handleSubmit = async e => {
        e.preventDefault();
        const token = await loginUser({
          f,  
          username,
          password
        });
        console.log("Set Token: "+ token);
        setToken(token);
        openSocket();

    }

    async function loginUser(credentials) {
        console.log(credentials);
    
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': ''
        }
    
        return axios
        .post('http://remote.amesrl.it/php/new-query.php', JSON.stringify(credentials),
        {
            "headers": headers
        })
        .then(response =>{
            console.log(response);
            if(response.status === 200){
                if(response.data.jwt){
                    
                    secureLocalStorage.setItem('username', username);
                    secureLocalStorage.setItem('hash', response.data.hash);
                    secureLocalStorage.setItem('token', response.data.jwt);
                    secureLocalStorage.setItem('refToken', response.data.jwtRefresh);
                    secureLocalStorage.setItem('port', response.data.port);
                    secureLocalStorage.setItem('sessionRef', response.data.sessionRef);
                
                    return response.data.jwt;
                }else
                    return -1;
            }
        })
        .catch(
         error => {
           // alert( "Unauthorized" + error);
        });
    }

    return (
      <div className="global-container">
        <div className="card login-form">
            <div className="card-body">
                <h3 className="card-title text-center">Remote Control</h3>
                <h4 className="card-title text-center">AME Srl</h4>
                <div className="card-text"> 
                  <form>         
                    <div className="form-group">
                        <label className="lbl-login" htmlFor="exampleInputEmail1">Username</label>
                            <input type="text" className="form-control form-control-sm" defaultChecked={false} onChange={e => setUserName(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label className="lbl-login" htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control form-control-sm" onChange={e => setPassword(e.target.value)} />
                    </div>
                    <div className='container'>
                        <button  type="submit" className="btn btn-primary btn-login" onClick={handleSubmit}>Access</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
      </div>
    );

}

export default Login;